import { createSlice } from "@reduxjs/toolkit";
import {
  postAuth,
  signUp,
  signIn,
  signInGuest,
  getOtp,
  sendOtp,
  validateOtp,
} from "../action/auth";

const initialState = {
  data: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    // setAuth: (state, { payload }) => {
    //   state.data = payload;
    // },
    [postAuth.fulfilled]: (state, { payload }) => {
      state.data = payload;
    },
    [postAuth.rejected]: (state, { payload }) => {
      state.data = payload; 
    },
    [signInGuest.fulfilled]: (state, payload ) => {
      state.data = payload.data;
    },
    [signInGuest.rejected]: (state, { payload }) => {
      state.data = payload.data.data;
    },
    [signUp.fulfilled]: (state, { payload }) => {
      state.data = payload.data;
    },
    [signUp.rejected]: (state, { payload }) => {
      state.data = payload;
    },
    [signIn.fulfilled]: (state, { payload }) => {
      state.data = payload;
    },
    [signIn.rejected]: (state, { payload }) => {
      state.data = payload;
    },
    [getOtp.fulfilled]: (state, { payload }) => {
      state.data = payload;
    },
    [getOtp.rejected]: (state, { payload }) => {
      state.data = payload;
    },
    [sendOtp.fulfilled]: (state, { payload }) => {
      state.data = payload;
    },
    [sendOtp.rejected]: (state, { payload }) => {
      state.data = payload;
    },
    [validateOtp.fulfilled]: (state, { payload }) => {
      state.data = payload;
    },
    [validateOtp.rejected]: (state, { payload }) => {
      state.data = payload;
    },
  },
});

export default authSlice;
